import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelPriceTable extends Layout {
    buttonRefreshPrices: Button;
    labelMonthly: Label;
    labelWeekly: Label;
    sourceFuelPrice: DataSource;
    sourceFuelPriceMonthly: DataSource;
    tableMonthly: Table;
    tableWeekly: Table;
}
